/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ImuTapPayload
 */
export interface ImuTapPayload {
    [key: string]: any | any;
    /**
     * 
     */
    type: ImuTapPayloadTypeEnum;
    /**
     * 
     */
    tapEventType: string;
    /**
     * 
     */
    tapCount: number;
}


/**
 * @export
 */
export const ImuTapPayloadTypeEnum = {
    ImuTap: 'imu_tap',
} as const;
export type ImuTapPayloadTypeEnum = typeof ImuTapPayloadTypeEnum[keyof typeof ImuTapPayloadTypeEnum];


/**
 * Check if a given object implements the ImuTapPayload interface.
 */
export function instanceOfImuTapPayload(value: object): value is ImuTapPayload {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (value['type'] !== 'imu_tap') return false;
    
    if ((!('tapEventType' in (value as Record<string, any>)) && !('tap_event_type' in (value as Record<string, any>))) || ((value as Record<string, any>)['tapEventType'] === undefined && (value as Record<string, any>)['tap_event_type'] === undefined)) return false;
    if ((!('tapCount' in (value as Record<string, any>)) && !('tap_count' in (value as Record<string, any>))) || ((value as Record<string, any>)['tapCount'] === undefined && (value as Record<string, any>)['tap_count'] === undefined)) return false;
    return true;
}

export function ImuTapPayloadFromJSON(json: any): ImuTapPayload {
    return ImuTapPayloadFromJSONTyped(json, false);
}

export function ImuTapPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImuTapPayload {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'type': json['type'],
        'tapEventType': json['tap_event_type'],
        'tapCount': json['tap_count'],
    };
}

export function ImuTapPayloadToJSON(json: any): ImuTapPayload {
    return ImuTapPayloadToJSONTyped(json, false);
}

export function ImuTapPayloadToJSONTyped(value?: ImuTapPayload | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'type': value['type'],
        'tap_event_type': value['tapEventType'],
        'tap_count': value['tapCount'],
    };
}

